import React from 'react';

const KeyboardArrowLeft = () => (
  <svg
    focusable="false"
    aria-hidden="true"
    width="1.2em"
    height="1.2em"
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m11 18 1.41-1.41L7.83 12l4.58-4.59L11 6l-6 6z" />
  </svg>
);

export default KeyboardArrowLeft;
